var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { Layer } from 'bernie-view';
import { logger, mergeQueryString, QueryRoute, updateSearch } from 'bernie-core';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { LocalizedText, useLocalization } from '@shared-ui/localization-context';
import { ESSAdapter, UitkTypeahead } from 'uitk-react-typeahead';
import { UitkButtonSize, UitkPrimaryButton, UitkTertiaryButton } from 'uitk-react-button';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSheetTransition } from 'uitk-react-sheet';
import { UitkSpacing } from 'uitk-react-spacing';
import { useStores } from '../../utils/hooks';
import { getFormInputParams } from '../../helpers/get-form-input-params';
import { getIsoFormatDateFromDateString } from '../../helpers/date-helper';
import { getPageId } from '../../helpers/common-helper';
import { DateField } from './date-field';
export var SearchUpdate = logger('activity-search')(observer(function (_a) {
  var loading = _a.loading,
    numDaysBookableInAdvance = _a.numDaysBookableInAdvance,
    onMobile = _a.onMobile,
    onSubmit = _a.onSubmit,
    searchQuery = _a.searchQuery,
    searchFormHeadingRef = _a.searchFormHeadingRef;
  var _b = useStores(),
    activitySearchStore = _b.activitySearchStore,
    context = _b.context,
    analytics = _b.analytics;
  var history = useHistory();
  var location = useLocation();
  var formatText = useLocalization().formatText;
  var inputRef = React.useRef(null);
  var formRef = React.useRef(null);
  var _c = __read(React.useState(false), 2),
    isSubmitDisabled = _c[0],
    setIsSubmitDisabled = _c[1];
  var _d = __read(React.useState({}), 2),
    searchQueryState = _d[0],
    setSearchQuery = _d[1];
  var _e = __read(React.useState({}), 2),
    searchFormErrors = _e[0],
    setSearchFormErrors = _e[1];
  var _f = __read(React.useState(''), 2),
    pageId = _f[0],
    setPageId = _f[1];
  React.useEffect(function () {
    setPageId(getPageId(activitySearchStore));
  }, [activitySearchStore]);
  var errorHandler = function (key, errorString) {
    setSearchFormErrors(function (error) {
      var _a;
      return __assign(__assign({}, error), (_a = {}, _a[key] = errorString || '', _a));
    });
  };
  var validateDestination = function (destination) {
    errorHandler('destinationError');
    if (!destination) {
      errorHandler('destinationError', 'Destination not selected.');
      return false;
    }
    return true;
  };
  var validateDates = function (startDate, endDate) {
    errorHandler('endDateError');
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    var _a = __read([1000, 3600, 24, 14], 4),
      MILLISEC = _a[0],
      SECONDSINHOUR = _a[1],
      HOURSINDAY = _a[2],
      LIMIT = _a[3];
    if (Math.ceil(Math.abs(new Date(startDate).getTime() - new Date(endDate).getTime()) / (MILLISEC * SECONDSINHOUR * HOURSINDAY)) > LIMIT) {
      errorHandler('endDateError', formatText('lx.activity.search.date.error'));
      return false;
    }
    return true;
  };
  var validateForm = function () {
    var _a = getFormInputParams(formRef),
      startDate = _a.startDate,
      endDate = _a.endDate,
      location = _a.location;
    return validateDates(startDate, endDate) && validateDestination(location);
  };
  var updateSubmitDisabled = function () {
    setIsSubmitDisabled(!validateForm());
  };
  var formatDateString = function (dateString) {
    return getIsoFormatDateFromDateString(dateString, context.localDateFormat);
  };
  var handleSubmit = function (event) {
    event.preventDefault();
    if (validateForm()) {
      onSubmit(getFormInputParams(formRef));
    }
  };
  var handleDateRangeChange = function () {
    var isValidForm = validateForm();
    var updateSearchRfrrId = "LX.".concat(pageId, ".UpdateSearch");
    setIsSubmitDisabled(!isValidForm);
    if (isValidForm) {
      onSubmit(getFormInputParams(formRef));
    }
    analytics.trackEvent(updateSearchRfrrId, 'update-search-clicked', analytics.omnitureData);
  };
  var handleChange = function (event) {
    return __awaiter(void 0, void 0, Promise, function () {
      var eventTarget, endDateIndex;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            eventTarget = event.target;
            endDateIndex = 1;
            return [4 /*yield*/, setSearchQuery(function (query) {
              var _a;
              return __assign(__assign({}, query), {
                startDate: eventTarget[0].value,
                endDate: ((_a = eventTarget[endDateIndex]) === null || _a === void 0 ? void 0 : _a.value) || eventTarget[0].value
              });
            })];
          case 1:
            _a.sent();
            // method trigger only needed after state update.
            errorHandler('endDateError');
            return [4 /*yield*/, handleDateRangeChange()];
          case 2:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  var updateTypeahead = function (typeaheadResult) {
    var _a, _b, _c;
    if (!typeaheadResult.term || typeaheadResult.term === '') {
      return;
    }
    var updatedQuery = __assign(__assign(__assign({}, getFormInputParams(formRef)), {
      slimSearchKeyword: '',
      rid: ''
    }), {
      location: (_c = (_b = (_a = typeaheadResult.data) === null || _a === void 0 ? void 0 : _a.regionNames) === null || _b === void 0 ? void 0 : _b.fullName) !== null && _c !== void 0 ? _c : typeaheadResult.term
    });
    var startDate = updatedQuery.startDate,
      endDate = updatedQuery.endDate,
      location = updatedQuery.location;
    var isValid = validateDates(startDate, endDate) && validateDestination(location);
    setIsSubmitDisabled(!isValid);
    onSubmit(updatedQuery);
  };
  var openTypeahead = function () {
    var destinationClickRfrrId = "LX.".concat(pageId, ".ChangeSearchDestinationClicked");
    updateSearch({
      history: history,
      location: location,
      newParams: {
        pwaDialog: 'destinationTypeahead'
      }
    });
    analytics.trackEvent(destinationClickRfrrId, 'change-search-destination-clicked', analytics.omnitureData);
  };
  var dismissTypeahead = function () {
    var query = mergeQueryString(history.location.search, {
      pwaDialog: ''
    });
    history.push({
      pathname: location.pathname,
      search: query,
      state: {}
    });
    updateSubmitDisabled();
  };
  var renderHotelNameFilterDialog = function (children) {
    return React.createElement(QueryRoute, {
      query: {
        pwaDialog: 'destinationTypeahead'
      }
    }, React.createElement(UitkSheetTransition, {
      isVisible: true
    }, React.createElement(Layer, {
      id: "destinationTypeahead",
      onDismiss: dismissTypeahead
    }, children)));
  };
  var handleClear = function () {
    updateSubmitDisabled();
  };
  var handleCloseButtonClick = function () {
    var query = mergeQueryString(location.search, {
      srpOpen: null
    });
    history.replace({
      pathname: location.pathname,
      search: query,
      state: {}
    });
    handleClear();
  };
  // defaults to the props, but override by updating the state
  var searchQueries = __assign(__assign({}, searchQuery), searchQueryState);
  var routerLinkWrapper = function (children) {
    return React.createElement(React.Fragment, null, children);
  };
  var dateFieldProps = {
    endId: 'activity-end-date',
    endInvalid: searchFormErrors.endDateError,
    endLabel: formatText('lx.search.endDate.label'),
    endName: 'endDate',
    onChange: handleChange,
    routerLinkWrapper: routerLinkWrapper,
    startId: 'activity-start-date',
    startLabel: formatText('lx.search.startDate.label'),
    startName: 'startDate'
  };
  var rfrr = {
    end: "LX.".concat(pageId, ".SearchWizard.EndDate"),
    start: "LX.".concat(pageId, ".SearchWizard.StartDate")
  };
  var commonDateFieldProps = {
    startDate: formatDateString(searchQueries.startDate),
    endDate: formatDateString(searchQueries.endDate),
    onChange: handleChange,
    daysBookableInAdvance: numDaysBookableInAdvance,
    buttonText: formatText('lx.search.searchButton')
  };
  return React.createElement(UitkSpacing, {
    padding: onMobile ? {
      inline: 'two',
      blockstart: 'two',
      blockend: 'four'
    } : {
      blockstart: 'two',
      blockend: 'four'
    }
  }, React.createElement("fieldset", {
    disabled: loading,
    "aria-busy": loading,
    "data-testid": "search-update--fieldset"
  }, React.createElement("form", {
    method: "get",
    action: "/things-to-do/search",
    onSubmit: handleSubmit,
    noValidate: true,
    ref: formRef,
    "data-testid": "search-update-form"
  }, React.createElement("h2", {
    className: "is-visually-hidden",
    ref: searchFormHeadingRef,
    tabIndex: -1
  }, React.createElement(LocalizedText, {
    message: "lx.search.changeSearch"
  })), React.createElement(UitkLayoutGrid, {
    columns: {
      medium: 12
    },
    space: "two",
    justifyContent: "start"
  }, React.createElement(UitkLayoutGridItem, {
    colSpan: {
      medium: 5
    }
  }, React.createElement("div", {
    "data-testid": "search-update-form-activities-destination-input",
    className: "form-truncate"
  }, React.createElement(Experiment, {
    name: "Optimize_Number_Of_Typeahead_Suggestion"
  }, React.createElement(ExperimentControl, null, React.createElement(UitkTypeahead, {
    adapter: new ESSAdapter({
      dest: true,
      client: 'LXActivitiesSearchPage',
      features: 'ta_hierarchy|postal_code|contextual_ta|consistent_display',
      guid: context.deviceId,
      lob: 'LX',
      locale: context.locale,
      maxResults: 10,
      regionType: 287,
      siteId: context.site.id
    }),
    allowExactMatch: true,
    label: formatText('lx.search.destination.label'),
    icon: "place",
    name: "location",
    handleClear: handleClear,
    hasClearButton: false,
    onClick: openTypeahead,
    onDismiss: dismissTypeahead,
    onUpdate: updateTypeahead,
    renderDialog: renderHotelNameFilterDialog,
    stid: "activities-destination",
    value: searchQueries.location,
    ref: inputRef,
    invalid: searchFormErrors.destinationError
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(UitkTypeahead, {
    adapter: new ESSAdapter({
      dest: true,
      client: 'LXActivitiesSearchPage',
      features: 'ta_hierarchy|postal_code|contextual_ta',
      guid: context.deviceId,
      lob: 'LX',
      locale: context.locale,
      maxResults: 5,
      regionType: 287,
      siteId: context.site.id
    }),
    allowExactMatch: true,
    label: formatText('lx.search.destination.label'),
    icon: "place",
    name: "location",
    handleClear: handleClear,
    hasClearButton: false,
    onClick: openTypeahead,
    onDismiss: dismissTypeahead,
    onUpdate: updateTypeahead,
    renderDialog: renderHotelNameFilterDialog,
    stid: "activities-destination",
    value: searchQueries.location,
    ref: inputRef,
    invalid: searchFormErrors.destinationError
  })), React.createElement(ExperimentVariant, {
    bucket: 2
  }, React.createElement(UitkTypeahead, {
    adapter: new ESSAdapter({
      dest: true,
      client: 'LXActivitiesSearchPage',
      features: 'ta_hierarchy|postal_code|contextual_ta',
      guid: context.deviceId,
      lob: 'LX',
      locale: context.locale,
      maxResults: 6,
      regionType: 287,
      siteId: context.site.id
    }),
    allowExactMatch: true,
    label: formatText('lx.search.destination.label'),
    icon: "place",
    name: "location",
    handleClear: handleClear,
    hasClearButton: false,
    onClick: openTypeahead,
    onDismiss: dismissTypeahead,
    onUpdate: updateTypeahead,
    renderDialog: renderHotelNameFilterDialog,
    stid: "activities-destination",
    value: searchQueries.location,
    ref: inputRef,
    invalid: searchFormErrors.destinationError
  }))))), React.createElement(UitkLayoutGridItem, {
    colSpan: {
      medium: 4
    }
  }, React.createElement("div", {
    "data-testid": "search-update-form-activities-date-input"
  }, React.createElement(DateField, __assign({
    rfrr: rfrr,
    dateFieldProps: dateFieldProps
  }, commonDateFieldProps)))), React.createElement(UitkLayoutGridItem, {
    colSpan: {
      medium: 3
    }
  }, onMobile ? React.createElement("div", {
    "data-testid": "search-update-form-mobile-close-button"
  }, React.createElement(UitkTertiaryButton, {
    isFullWidth: true,
    onClick: handleCloseButtonClick
  }, formatText('lx.search.form.close'))) : React.createElement("div", {
    "data-testid": "search-update-form-desktop-search-button"
  }, React.createElement(UitkPrimaryButton, {
    isFullWidth: true,
    type: "submit",
    size: UitkButtonSize.LARGE,
    disabled: isSubmitDisabled
  }, formatText('lx.search.searchButton'))))))));
}));